import { render, staticRenderFns } from "./advertManageList.vue?vue&type=template&id=b84bde7e&scoped=true"
import script from "./advertManageList.vue?vue&type=script&lang=js"
export * from "./advertManageList.vue?vue&type=script&lang=js"
import style0 from "./advertManageList.vue?vue&type=style&index=0&id=b84bde7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84bde7e",
  null
  
)

export default component.exports